export const sectors = [
  {
    category: "Foreign Investors & Global Founders",
    item: [
      {
        title: "Navigate Nigeria's Complex Legal Landscape with a Business-First Legal Team",
        paragraph: "At Lawberon Legals & Co., we specialize in guiding foreign investors, global founders, and international businesses through the legal terrain of doing business in Nigeria. Whether you're setting up a new venture, investing in Nigerian assets, or expanding into Africa's largest market, we provide the strategic legal support to help you build confidently and compliantly.",
        details: [
          {
            heading: "🚀 Why Foreign Investors Choose Nigeria",
            desc: "Nigeria remains one of Africa's top destinations for foreign direct investment (FDI) due to its:",
            list1: "Massive consumer base (200M+ population)",
            list2: "Booming tech and fintech ecosystem",
            list3: "Resource-rich economy (oil, gas, agriculture, and minerals)",
            list4: "Strategic location for regional expansion",
            desc2: "But with opportunity comes complexity. Foreign founders face hurdles in registration, ownership structures, repatriation of funds, regulatory approvals, tax exposure, and compliance.",
          },
          {
            heading: "🧾 Legal Challenges Faced by Foreign Founders in Nigeria",
            desc: "Here are common pain points for international entrepreneurs entering the Nigerian market:",
            list1: "Company Incorporation Delays: Misalignment with CAC requirements or missing local compliance documents",
            list2: "Ownership Restrictions: Sector-specific limitations under the Nigerian Investment Promotion Commission (NIPC)",
            list3: "Regulatory Approvals: Licensing, permits, and approvals from NIPC, NOTAP, CBN, SEC, and more",
            list4: "Foreign Exchange Regulations: Repatriating profits and accessing the Investors’ & Exporters’ (I&E) FX window",
            list5: "IP Protection: Trademark registration and defending intellectual property locally",
            list6: "Taxation Risks: Double taxation, unexpected liabilities, or improper tax structuring",
            list7: "Employment & Immigration: Expatriate quotas, business visas, and local employment compliance",
          },
          {
            heading: "⚖️ Our Legal Solutions for Foreign Clients",
            desc: "We provide a full suite of tailored services for foreign investors and global entrepreneurs:",
            list1: "✅ Company Incorporation & Structuring",
            list2: "Incorporating wholly foreign-owned companies",
            list3: "Structuring Joint Ventures or Nigerian subsidiaries",
            list4: "Shareholding design and BOI compliance",
            list5: "✅ NIPC Registration & Pioneer Status Applications",
            list6: "Fast-track NIPC registration",
            list7: "Advising on Pioneer Status Incentives (tax holidays for eligible sectors)",
            list8: "✅ Regulatory Licensing & Compliance",
            list9: "Guidance on all regulatory requirements (CBN, SEC, NCC, NAFDAC, etc.)",
            list10: "Licensing for fintech, import/export, health, education, and more",
            list11: "✅ Intellectual Property Protection",
            list12: "Trademark, copyright, and patent registration",
            list13: "IP due diligence and portfolio management",
            list14: "✅ Immigration & Expat Services",
            list15: "Business permits, expatriate quota processing, and visa support",
            list16: "Legal HR compliance and employment contracts",
            list17: "✅ Foreign Exchange & Tax Advisory",
            list18: "Structuring for profit repatriation",
            list19: "Double tax treaty application and advisory",
            list20: "Local tax compliance and incentives",
          },
          {
            heading: "🧠 Use Cases: Helping Foreign Clients Win in Nigeria",
            list1: "A US fintech startup partnering with Nigerian payment companies needed CBN licensing guidance and IP protection — we delivered both in record time.",
            list2: "A Dubai-based real estate firm required structuring for land acquisition and NIPC registration — we handled all with full regulatory compliance.",
            list3: "A European logistics investor faced issues with repatriating funds — we restructured their compliance model and facilitated BOI and tax alignment.",
          },
        ],
        workWithUs: [
          {
            list: "✅ Deep understanding of both international expectations and local regulatory systems"
          },
          {
            list: "✅ Fast, responsive support tailored for global timelines"
          },
          {
            list: "✅ Dual advisory for legal and business strategy"
          },
          {
            list: "✅ Transparent, fixed-fee options for startup support"
          },
          {
            list: "✅ Discreet handling of high-value investments"
          }
        ],
      }
    ],
  },
  {
    category: "Nigerian Entrepreneurs & SMEs",
    item: [
      {
        title: "Empowering Ambition with the Right Legal Structure",
        paragraph: "Nigeria is a nation of dreamers and doers — from side-hustlers and content creators to fast-growing eCommerce brands and service providers. But while ambition is in no short supply, many promising businesses struggle due to poor legal structures, unclear contracts, or unresolved regulatory hiccups.",
        paragraph2: "At Lawberon Legals & Co., we offer business-first legal support for Nigerian entrepreneurs, startups, and SMEs — helping you start, grow, and protect your business with clarity and confidence.",
        details: [
          {
            heading: "Smart Legal Support for Every Stage of Your Business",
            desc: "💡 Whether you're registering your first business name or onboarding your first investor, we provide practical legal guidance built around the realities of doing business in Nigeria.",
            list1: "✅ Starting Strong – Incorporation & Business Structure",
            list2: "CAC Registration: Business Name, Limited Liability Company (LLC), NGOs, and Partnerships",
            list3: "Founders’ Agreements: Align co-founders from day one with legally binding terms",
            list4: "Corporate Structuring: Choose the right legal entity for tax, ownership, and scalability",
            desc2: "“We help you move from a brilliant idea to a bankable business — with clean, investor-ready documentation.”",
          },
          {
            heading: "💼 Contracts That Protect Your Hustle",
            desc: "Your contracts are your first line of defense in business — don’t run operations on handshakes or DMs.",
            list1: "Vendor & Client Agreements",
            list2: "Partnership and Joint Venture Contracts",
            list3: "Service Level Agreements (SLAs)",
            list4: "NDAs and Confidentiality Agreements",
            list5: "Employment Contracts (Full-time, Freelance, Commission-based)",
          },
          {
            heading: "🔐 Protecting Your Brand & Ideas (Intellectual Property)",
            desc: "That logo, slogan, content or product packaging you created? It deserves legal protection — especially before someone else copies it.",
            list1: "Trademark Search & Registration (Nigeria & Africa-wide)",
            list2: "Copyright for Creatives (Music, Art, Videos, Digital Assets)",
            list3: "IP Monitoring and Infringement Response",
            list4: "Brand Licensing & Transfer Agreements",
            desc2: "Your brand is your business — we’ll help you own it.",
          },
          {
            heading: "💸 Tax, CAC & Regulatory Compliance",
            desc: "Don’t let penalties or missed deadlines hold you back.",
            list1: "Annual CAC Filings & Updates",
            list2: "TIN, FIRS, VAT, and Company Income Tax Advisory",
            list3: "Registration with NSITF, ITF, PENCOM, etc.",
            list4: "Nigerian Data Protection (NDPR) Compliance for Online Businesses",
          },
          {
            heading: "🚀 Fundraising, Partnerships & Growth",
            desc: "Whether you’re pitching your first investor or exploring local collaborations, we’ll make sure the legal side is as solid as your pitch deck.",
            list1: "Investor Agreements and SAFE Notes",
            list2: "Legal Due Diligence",
            list3: "Franchise & Licensing Agreements",
            list4: "Memorandum of Understanding (MOU) Drafting",
          },
        ],
        workWithUs: [
          {
            list: "✅ Business-savvy lawyers who understand Nigeria’s regulatory terrain"
          },
          {
            list: " ✅ Transparent, fixed-fee packages designed for startups and SMEs"
          },
          {
            list: " ✅ Fast turnaround and responsive communication"
          },
          {
            list: "✅ Clear legal advice without unnecessary jargon"
          },
          {
            list: " ✅ Flexible support across Lagos, Abuja, and remote businesses nationwide"
          }
        ],
      }
    ],
  },
  {
    category: "Tech Startups & Digital Founders",
    item: [
      {
        title: "“Launch Fast. Scale Smart. Stay Compliant.”",
        paragraph: " We help Nigerian and global tech founders navigate the legal side of innovation — from incorporation to compliance, capital raising to IP protection.",
        details: [
          {
            heading: "👋 Welcome, Digital Disruptors",
            desc: "Nigeria’s tech ecosystem is booming — from fintech to healthtech, proptech to edtech. But legal mistakes still kill promising startups every day.",
            list1: "At Lawberon, we exist to ensure your startup isn’t one of them.",
            desc2: "Whether you're bootstrapping a SaaS product, preparing to raise VC funds, or scaling across Africa, we offer agile legal solutions tailored to Nigeria’s fast-moving tech space — so you can innovate boldly, without blind spots.",
          },
          {
            heading: "🏗️ Startup Incorporation & Founder Agreements",
            desc: "Launch the right way from Day One",
            list1: "Advisory on best incorporation structures under CAMA (Limited, HoldCo, SPVs)",
            list2: "Shareholders’ Agreements & Founder Vesting Clauses",
            list3: "Startup equity splits, cap table structuring & cliff/vesting schedules",
            list4: "Founder employment terms, IP assignment, non-compete clauses",
            list5: "Regulatory filings & documentation (CAC, TIN, SCUML, etc.)",
            desc2: "We help prevent co-founder fallouts and ownership disputes.",
          },
          {
            heading: "📜 Regulatory Compliance for Tech Products",
            desc: "Launch legally-compliant MVPs and apps",
            list1: "Data privacy compliance (NDPC Nigeria, GDPR alignment)",
            list2: "Terms of Use, Privacy Policies, SaaS/MSA Contracts",
            list3: "Fintech licensing under CBN, SEC, or NITDA as applicable",
            list4: "NOTAP compliance for software licensing and foreign tech partnerships",
            list5: "AML/KYC obligations for tech platforms handling user data or payments",
            desc2: " We help you scale with clarity — not legal guesswork.",
          },
          {
            heading: "💰 Fundraising & Investor Readiness",
            desc: "Raise capital with confidence",
            list1: "SAFE Notes, Convertible Notes, and equity term sheet reviews",
            list2: "Due diligence prep: corporate governance, IP ownership, founder contracts",
            list3: "Regulatory advisory for foreign VC investment (CBN + NIPC)",
            list4: "Shareholder rights, preference shares & investor protections",
            list5: "Drafting & negotiation of investment agreements",
            desc2: "We help ensure your startup is 'VC-grade' from a legal lens."
          },
          {
            heading: "🔐 IP Protection for Innovation",
            desc: "Don’t launch your product without locking in your rights",
            list1: "Trademark registration (Nigeria + ARIPO/OAPI + international)",
            list2: "Software license agreements & copyright protections",
            list3: "Trade secret and NDAs for team and vendor protections",
            list4: "IP assignments & founder-to-startup transferss",
            list5: "Brand and product name clearance",
            desc2: "We help you build a brand that’s protected, not pirated."
          },
          {
            heading: "🤝 Contracts & Tech Partnership Agreements",
            desc: "Build smart legal rails for scale",
            list1: "Service Level Agreements (SLAs)",
            list2: "White-label & reseller contracts",
            list3: "Developer and vendor contracts",
            list4: "API usage terms & data sharing agreements",
            list5: "Joint venture agreements for tech collaborations",
            desc2: " We draft contracts that match startup speed — and protect your upside."
          },
          {
            heading: "🧾 Tax, Structuring & Compliance Strategy",
            desc: "Stay audit-ready and tax-smart",
            list1: "VAT & WHT compliance for tech companies",
            list2: "Startup-friendly tax structuring under Nigerian law",
            list3: "Advisory on tech startup tax exemptions/incentives",
            list4: "International structuring: Holding companies & IP boxes",
            list5: "Ongoing compliance calendars & audit prep",
            desc2: "We demystify taxes and build lean structures that scale."
          },
          {
            heading: "⚖️ Dispute Prevention & Founder Exits",
            desc: "Plan for what can go wrong — before it does",
            list1: "Founder & shareholder exits",
            list2: "Arbitration clauses & dispute resolution strategies",
            list3: "IP disputes, software license breaches",
            list4: "Employee disputes and termination protections",
            list5: "Pre-emptive legal audits",
            desc2: " We help you scale with safety nets, not stress."
          },
        ],
        workWithUs: [
          {
            list: "🚀 Startup-native lawyers who speak your language"
          },
          {
            list: "📱 Tech-literate, product-savvy, agile in delivery"
          },
          {
            list: "🧠 Experienced with Nigerian regulations + global startup models"
          },
          {
            list: "🧾 Transparent pricing for bootstrappers and venture-backed teams"
          },
          {
            list: "🌍 Dual support for local & cross-border tech expansion"
          }
        ],
      }
    ],
  },
  {
    category: "Real Estate Developers & Property Investors",
    item: [
      {
        title: "Build Without Legal Bottlenecks",
        paragraph: "We help real estate developers and property investors navigate Nigeria’s complex legal, regulatory, and title systems with clarity and confidence.",
        details: [
          {
            heading: "Nigeria's Real Estate Boom: Profitable, But Not Plug-and-Play",
            desc: "Nigeria’s fast-growing population, urban migration, and housing deficit (estimated at over 17 million units) make real estate a prime sector for wealth creation. From Lagos to Abuja and Port Harcourt, demand for housing and commercial properties is rising. But legal landmines remain:",
            list1: "Fraudulent land titles",
            list2: "Omo-Onile interference",
            list3: "Government policy delays",
            list4: "Poorly structured JV deals",
            desc2: "Lawberon Legals is your legal compass for navigating all of it—from site selection to final sale.",
          },
          {
            heading: "Land Acquisition & Due Diligence Support",
            desc: "Before you buy or commit to any land, we help you:",
            list1: "Verify title: from Excision to Gazette, C of O, and Deed of Assignment",
            list2: "Investigate encumbrances and litigation risks",
            list3: "Confirm land use classification and government ownership",
            list4: "Run full property searches at the Land Registry and Surveyor General’s Office",
            list7: "We provide you a full Due Diligence Report so you know exactly what you’re buying",
          },
          {
            heading: "Joint Ventures & Real Estate Partnerships",
            desc: "JVs are the norm for property development in Nigeria, especially between developers and landowners. We help you:",
            list1: "Structure safe JV Agreements (JVA) with clear equity splits",
            list2: "Draft and negotiate Development Agreements and Profit Sharing clauses",
            list3: "Set up SPVs (Special Purpose Vehicles) to manage JV operations and liabilities",
            desc2: "With Lawberon, your partnerships are built on clear contracts, not handshakes.",
          },
          {
            heading: "Property Sales & Transaction Advisory",
            desc: "Selling land or off-plan units? We guide you through:",
            list1: "Contract of Sale, Deed of Assignment, and Power of Attorney",
            list2: "Property agency law, commission agreements, and compliance",
            list3: "Investor documentation and off-plan buyer protections",
            desc2: "We also offer escrow services to hold title documents until payment is completed."
          },
          {
            heading: "Title Perfection & Post-Closing Support",
            desc: "After acquisition or sale, you still need to:",
            list1: "Get Governor’s Consent",
            list2: "Stamp and register documents at the Land Registry",
            list3: "Secure indemnities, NDAs, or caveats as needed",
            desc2: "We handle all perfection steps so your ownership is fully recognized under Nigerian law."
          },
          {
            heading: "Real Estate Disputes & Litigation Strategy",
            desc: "Should disputes arise, we represent you in:",
            list1: "Omo-Onile land encroachment and ownership challenges",
            list2: "Contract breaches and JV fallouts",
            list3: "Recovery of real estate investments via litigation or arbitration",
            desc2: "Our lawyers are trained to de-escalate conflicts, but we fight hard when we must."
          },
        ],
        workWithUs: [
          {
            list: "✅ Dedicated property law team with real-world experience"
          },
          {
            list: "✅ Strong relationships with land bureaus and regulatory bodies"
          },
          {
            list: "✅ Fast-track title search and perfection support"
          },
          {
            list: "✅ Virtual updates and transparent billing"
          },
          {
            list: "✅ We don’t just practice law—we understand the business of property."
          }
        ],
      }
    ],
  },
  {
    category: "Creative Professionals & Content Creators",
    item: [
      {
        title: "Protect Your Work. Power Your Creativity.",
        paragraph: " Legal support for Nigeria’s creators, producers, and media entrepreneurs — from copyright to contracts, licensing to brand deals.",
        details: [
          {
            heading: "🎨 Welcome, Creative Visionaries",
            desc: "Nigeria’s creative economy is a global force — from Afrobeats to Nollywood, YouTube creators to digital agencies. But legal protection hasn’t always kept up with the pace of innovation.",
            desc2: "At Lawberon Legals, we help content creators and media entrepreneurs protect their intellectual property, monetize their work legally, and avoid costly legal mistakes. Whether you're an independent artist, filmmaker, music label, or influencer, we’ve got your legal playbook covered.",
          },
          {
            heading: "📄 Creative Contracts & Production Agreements",
            desc: "Solid deals that protect your vision and income",
            list1: "Talent contracts for actors, influencers, models, and collaborators",
            list2: "Music production & publishing agreements",
            list3: "YouTube/Instagram/TikTok content collaboration agreements",
            list4: "Licensing deals with brands and agencies",
            list5: "Distribution, performance, and royalty-sharing contracts",
            list7: "Avoid handshake deals that lead to heartbreak.",
          },
          {
            heading: "©️ Copyright & IP Protection for Creatives",
            desc: "Own your work. Control how it's used.",
            list1: "Copyright registration with the Nigerian Copyright Commission (NCC)",
            list2: "Legal protection for songs, scripts, films, photography, and designs",
            list3: "IP assignments and collaboration rights clarity",
            list4: "Licensing of your work for third-party usage",
            list5: "Monitoring and enforcement of copyright infringement",
            desc2: "✅ We help you secure royalties and prevent IP theft.",
          },
          {
            heading: "💰 Digital Monetization & Brand Collaborations",
            desc: "Make money with peace of mind",
            list1: "Influencer marketing agreements with brands and agencies",
            list2: "Advertising revenue splits and digital platform policies",
            list3: "Royalty agreements for music, podcasts, and streaming",
            list4: "Dispute clauses and usage rights for commercial collabs",
            list5: "Contract audits before signing new brand deals",
            desc2: "✅ We protect your earning potential across digital channels.",
          },
          {
            heading: "🎥 Film, TV & Content Production Legal Support",
            desc: "From script to screen — legally sound productions",
            list1: "Production company incorporation & contracts",
            list2: "Location releases, performer consents & copyright clearances",
            list3: "Crew agreements, usage rights, and licensing",
            list4: "Legal review of distribution and syndication agreements",
            list5: "Festival, cinema, and online release agreements",
            desc2: "✅ Your production deserves legal muscle behind the magic.",
          },
          {
            heading: "🚨 Defamation, Publicity & Content Risk Management",
            desc: "Don’t let one video become a legal disaster",
            list1: "Pre-publication legal review of risky content",
            list2: "Defamation, reputation, and public image protections",
            list3: "Clearance of names, brands, and likeness rights",
            list4: "Social media takedowns and digital reputation defense",
            list5: "NDAs and confidentiality agreements for unreleased work",
            desc2: "✅ We help you create boldly without crossing legal lines.",
          },
        ],
        workWithUs: [
          {
            list: "🎭 Creative-industry fluency — we understand your hustle"
          },
          {
            list: "📱 Fast, digital-first support — contracts, reviews, filings"
          },
          {
            list: "🧠 IP-savvy and rights-focused lawyers"
          },
          {
            list: "💼 Flat-fee packages designed for creators and teams"
          },
          {
            list: "📍 Lagos-based, global-ready legal solutions"
          }
        ],
      }
    ],
  },
  {
    category: "High-Net-Worth Individuals (HNIs) & Family Offices",
    item: [
      {
        title: "Private Wealth Deserves Private Counsel",
        paragraph: "Discreet legal solutions for Nigeria’s elite and diasporan professionals — from property investments to succession planning.",
        details: [
          {
            heading: "Why HNIs Need Strategic Legal Support",
            desc: "Nigeria’s community of high-net-worth individuals (HNIs) is growing, fueled by entrepreneurial success, corporate leadership, oil & gas wealth, and diasporan remittances. But with this rise in wealth comes increased legal exposure — from property fraud to succession battles and poorly structured assets.",
            desc2: "At Lawberon Legals, we offer strategic legal support tailored to HNIs who demand precision, confidentiality, and cross-border insight. Our team understands the nuances of family, financial, and business law that impact the ultra-affluent.",
          },
          {
            heading: "Wealth Structuring & Asset Protection",
            desc: "Whether you're building generational wealth or safeguarding what you already have, the right legal framework matters. We help HNIs:",
            list1: "Set up holding companies and SPVs for asset control and tax efficiency",
            list2: "Establish discretionary trusts and offshore structures for legacy planning",
            list3: "Navigate Nigeria’s inheritance laws and family property rights",
            desc2: "With our advice, you can maintain legal control, reduce tax exposure, and protect your estate from future disputes.",
          },
          {
            heading: "Real Estate Acquisition & Due Diligence",
            desc: "Prime real estate in Lagos, Abuja, or your hometown should never be bought on trust alone. Our team conducts:",
            list1: "Land title verification with State Land Registries",
            list2: "Legal due diligence on developers, vendors, and estate schemes",
            list3: "Drafting and negotiation of real estate contracts and deeds",
            desc2: "Avoid property scams and land disputes — our team ensures your property portfolio is watertight.",
          },
          {
            heading: "Business Succession & Estate Planning",
            desc: "Many HNIs don’t plan for tomorrow until it’s too late. We help:",
            list1: "Draft enforceable wills under Nigerian law",
            list2: "Create family constitutions and business succession agreements",
            list3: "Navigate probate processes and secure letters of administration",
            desc2: "We guide families in preserving unity, preventing litigation, and ensuring wealth transfer across generations.",
          },
          {
            heading: "Discreet Dispute Resolution & Advisory",
            desc: "HNIs often face sensitive legal issues — inheritance conflicts, divorce, shareholder fights. We provide:",
            list1: "Confidential mediation and arbitration services",
            list2: "High-touch concierge legal advisory",
            list3: "Litigation only when necessary, with full discretion",
            desc2: "We resolve legal issues behind closed doors, without newspaper headlines or family fallout.",
          },
          {
            heading: "Immigration, Residency & Citizenship-by-Investment Support",
            desc: "For diasporan Nigerians and globally mobile professionals, we support:",
            list1: "Golden visa and second passport applications (UAE, EU, etc.)",
            list2: "CERPAC, business permits, and local compliance for foreign-born spouses",
            list3: "Cross-border estate and asset repatriation planning",
            desc2: "Wherever you live, we make your Nigerian assets and legal rights secure.",
          }
        ],
        workWithUs: [
          {
            list: "✅ Discreet Expertise: We protect your privacy at all costs"
          },
          {
            list: "✅ International-Local Fluency: Nigerian law + global coordination"
          },
          {
            list: "✅ Tailored Solutions: No templates, just what fits your lifestyle"
          },
          {
            list: "We serve legacy families, diasporan professionals, celebrities, and new money founders alike."
          },
        ],
      }
    ],
  },
  {
    category: "Healthcare & Medical Enterprises",
    item: [
      {
        title: "🩺 The Pulse of Nigeria’s Healthcare Sector (and Where Law Meets Medicine)",
        paragraph: "Nigeria’s healthcare ecosystem is evolving rapidly — from traditional hospitals and diagnostic labs to bold new ventures in digital health and medtech. Local medical entrepreneurs, diaspora doctors, healthtech founders, and private investors are building clinics, launching apps, and improving access to care.",
        paragrap2: "But with that growth comes serious legal responsibility. From NAFDAC registration and data protection compliance to doctor contracts and IP disputes — healthcare isn’t just about healing people, it’s about protecting your practice.",
        paragrap3: "That’s where Lawberon Legals comes in. We act as your legal partner, helping you build, license, protect, and scale your medical or healthtech venture — while staying compliant with Nigeria’s complex health regulations.",
        details: [
          {
            heading: "⚖️ Key Legal Challenges in Healthcare & Healthtech",
            desc: "Here’s what founders, clinic owners, and health innovators often face:",
            list1: "📋 Medical Licensing & Facility Registration Complying with MDCN, NAFDAC, NHIS, and HEFAMAA regulations for hospitals, labs, pharmacies, and digital health services.",
            list2: "🛡️ Regulatory Compliance Navigating strict guidelines on patient care, facility operations, and NDPR (Nigeria Data Protection Regulation) for digital platforms",
            list3: "💼 Employment & Contracts Crafting clear agreements for doctors, nurses, pharmacists, consultants, and foreign-trained professionals.",
            list4: "💸 Investments & Venture Deals Structuring SAFE notes, term sheets, and investor documentation for healthtech startups and private hospitals.",
            list5: "💡 Intellectual Property (IP) Protecting healthtech apps, telemedicine platforms, and diagnostic algorithms from copycats.",
            list6: "📱 Digital Health Risks Ensuring data security and NDPR compliance for apps that collect or store patient health records.",
          },
          {
            heading: "🛠️ Our Legal Solutions for the Health Sector",
            desc: "Whether you're a clinic owner, digital health startup, or medical supply chain operator, we offer tailored legal services:",
            list1: "✅ Hospital, Lab & Clinic Licensing",
            list2: "We handle regulatory approvals from MDCN, NAFDAC, HEFAMAA, and NHIS for private health facilities.",
            list3: "✅ Healthtech & Medtech IP Protection",
            list4: "Trademarks, patents, licensing agreements, and IP assignment deeds for health platforms.",
            list5: "✅ NDPR & Patient Data Compliance",
            list6: "Drafting data privacy policies, consent forms, and digital platform terms for telehealth or diagnostic apps.",
            list7: "✅ Co-founder & Investor Agreements",
            list8: "Structuring shareholding, capital contributions, SAFE notes, and ESOPs for early-stage medical startups.",
            list9: "✅ Healthcare Staff Agreements",
            list10: "Contract drafting for doctors, interns, nurses, and visiting specialists — including medical liability terms.",
          },
          {
            heading: "📌 Real-Life Scenarios We’ve Helped With",
            list1: "A diaspora doctor duo launching a private diagnostic center in Abuja and needing HEFAMAA licensing + doctor employment contracts.",
            list2: "A Lagos healthtech startup with a telemedicine platform that needed NDPR compliance, IP registration, and VC due diligence support.",
            list3: "A pharmaceutical supplier importing medical equipment and navigating NAFDAC licensing and international distribution terms.",
          },
        ],
        workWithUs: [
          {
            list: "🧠 We Understand Both the Science and the Structure: From licensing authorities to startup IP — we speak your industry’s language."
          },
          {
            list: "🌍 Local + International Client Support: Diaspora founders, NGOs, and foreign medical collaborators — we guide them all."
          },
          {
            list: "⚡ Fast Turnaround + Regulatory Fluency: We know the healthcare red tape — and we’re built to move through it quickly."
          },
        ],
      }
    ],
  },
  {
    category: "E-commerce & Digital Platforms",
    item: [
      {
        title: "Selling to Nigeria's 200 Million Consumers?",
        paragraph: "Smart brands need smarter legal support.",
        paragrap2: "The Nigerian retail and consumer market is massive, fast-moving, and increasingly digital. From fashion labels and beauty startups to e-commerce platforms and DTC food brands, the growth opportunities are endless. But so are the risks.",
        paragrap3: "Whether you're running a Shopify store from Lagos, exporting shea butter to Europe, or launching a new skincare line, legal compliance and brand protection should be foundational, not an afterthought.",
        paragraph4: "At Lawberon Legals, we partner with retail founders, e-commerce entrepreneurs, and FMCG players to structure operations, secure IP, and handle the fine print that powers customer-facing success.",
        details: [
          {
            heading: "Legal Challenges Retail & E-Commerce Players Face:",
            desc: "Inconsistent CAC registration or product labeling compliance",
            list1: "Intellectual property theft and counterfeiting",
            list2: "Vendor disputes and distribution issues",
            list3: "Social media influencer contracts gone wrong",
            list4: "Regulatory compliance with NAFDAC, SON, FCCPC",
            list5: "Data protection for customer information (NDPR compliance)",
            list6: "Tax and import/export regulatory confusion",
          },
          {
            heading: "Our Legal Solutions for Brands & Sellers:",
            desc: "Business Structure & Licensing: CAC incorporation, trade licenses, NAFDAC/SON approvals",
            list1: "Brand Protection & IP: Trademark registration, cease-and-desist letters, anti-counterfeiting action",
            list2: "Commercial Contracts: Influencer agreements, vendor contracts, reseller/distribution agreements",
            list3: "E-commerce Policies: Terms & conditions, privacy policies, refund terms compliant with FCCPC guidelines",
            list4: "Data Protection: NDPR compliance audits and privacy structuring for online platforms",
            list5: "Cross-border Compliance: Export documentation, customs advisory, trade contracts",
            desc2: "Whether you sell via Instagram, Jumia, or your own site — we help you stay compliant while scaling smart.",
          },
          {
            heading: "Sample Use Cases:",
            desc: "A fashion e-commerce brand scaling to 3 African markets needed help with brand trademarking, cross-border reseller contracts, and tax planning.",
            list1: "A beauty brand importing raw materials and selling NAFDAC-regulated products via Instagram needed regulatory approvals, privacy policy setup, and an influencer agreement.",
            list2: "A fast-moving consumer goods startup working with wholesalers and distributors needed watertight contracts to reduce losses and IP theft.",
            list3: "Structuring Joint Ventures or Nigerian subsidiaries",
          },
        ],
        workWithUs: [
          {
            list: "Brand-Savvy: We get modern commerce and creative business models"
          },
          {
            list: "Practical Contracts: No legalese, just sharp documents that work"
          },
          {
            list: "Cross-Border Fluency: We bridge local laws with your global ambitions"
          }
        ],
      }
    ],
  },
  {
    category: "Construction & Infrastructure Firms",
    item: [
      {
        title: "🏗️ Building Nigeria, Legally & Strategically",
        paragraph: "Legal clarity for real estate developers, civil engineers, PPP contractors, and multinational construction firms — from title due diligence to billion-naira arbitration.",
        details: [
          {
            heading: "The Legal Terrain for Builders in Nigeria",
            desc: "The construction and infrastructure sectors in Nigeria are booming — with private estates mushrooming across Lagos, public road projects in the North, and foreign-funded railway and energy infrastructure expanding nationwide. Yet behind every crane is a legal headache waiting to happen.",
            list1: "From land disputes with host communities to procurement delays, subcontractor disputes, and permit bottlenecks, developers need more than engineering skill — they need airtight legal protection.",
            list2: "Lawberon Legals serves as the strategic legal backbone for developers, contractors, foreign investors, and public-private partners involved in high-value construction and infrastructure projects in Nigeria.",
            desc2: "We don’t just draft documents — we help prevent deadlocks, enforce agreements, and keep your project on schedule and budget.",
          },
          {
            heading: "⚠️ Key Legal Challenges in Construction & Infrastructure",
            list1: "✅ Land Acquisition & Community Disputes",
            list2: "Host communities, family-owned lands, and unclear titles create major delays and disputes.",
            list3: "✅ Building & Zoning Approvals",
            list4: "Developers must navigate multiple agencies — town planning, physical planning, urban development — just to get started legally.",
            list5: "✅ Construction Contracts",
            list6: "Poorly structured contracts with contractors, engineers, and subcontractors often lead to endless variations, cost overruns, and court cases.",
          },
          {
            heading: "🛠️ Our Legal Solutions for Developers",
            desc: "At Lawberon Legals, we provide end-to-end legal support tailored for the construction and infrastructure ecosystem:",
            list1: "✅ Pre-Construction Phase",
            list2: "Land title investigation & legal due diligence (C-of-O, surveys, encumbrances)",
            list3: "Drafting & reviewing Joint Venture Agreements with landowners",
            list4: "Negotiating Development Rights & MoUs",
            list5: "✅ Contracting & Structuring",
            list6: "Drafting FIDIC, EPC, Design & Build, and Turnkey contracts",
            list7: "Setting up Special Purpose Vehicles (SPVs) or project companies",
            list8: "Corporate governance for Joint Ventures or consortiums",
            list9: "Local content compliance (for foreign companies)",
            list10: "✅ Regulatory Compliance",
            list11: "Processing building permits, physical planning approvals, and development control",
            list12: "NIPC approvals, PENCOM, ITF, NESREA & BPP registrations",
            list13: "Environmental Impact Assessments & ESG documentation",
            list14: "✅ Project Execution & Dispute Management",
            list15: "Drafting subcontractor, supplier, and equipment lease agreements",
            list16: "Managing change orders, variations, and breach scenarios",
            list17: "Arbitration, mediation, and litigation support",
            list18: "Retention clauses and performance bond enforcement",
            list19: "✅ Tax & Finance Support",
            list20: "Structuring foreign investment into Nigerian projects",
            list21: "Tax compliance & optimization (VAT, WHT, CGT)",
            list22: "Advising on infrastructure credits & capital allowances",
            desc2: "We bring a proactive approach to legal risk management — keeping your project investor-ready and regulator-proof.",
          },
        ],
        workWithUs: [
          {
            list: "✅ We understand both law and land — from title registrations to international construction contracting."
          },
          {
            list: "✅ Our team blends expertise in real estate, tax, public procurement, and dispute resolution."
          },
          {
            list: "✅ We assist foreign EPC contractors and investors working in Nigerian terrain."
          },
          {
            list: "✅ We know how to work with government MDAs and speed up legal processes."
          },
          {
            list: "✅ Our job is to prevent disputes, not just fight them after the damage is done."
          }
        ],
      }
    ],
  },
  {
    category: "Energy & Natural Resources (Oil, Gas & Renewables)",
    item: [
      {
        title: "Powering Growth with Legal Precision",
        paragraph: "We help energy producers, oil & gas firms, and renewable startups navigate Nigeria’s high-stakes regulatory terrain.",
        details: [
          {
            heading: "The Legal Landscape of Energy in Nigeria",
            desc: "Nigeria’s energy sector is a powerful engine for economic development, yet it is layered with regulatory complexity. From upstream oil licensing to power purchase agreements and local content compliance, legal missteps can mean delays, fines, or project shutdowns.",
            desc2: "Whether you’re an indigenous exploration company, a renewable energy startup, or a multinational investor, Lawberon Legals offers expert legal partnership in navigating this volatile terrain.",
          },
          {
            heading: "Key Legal Needs in the Energy & Extractives Sector",
            desc: "DPR/NUPRC licensing and renewals (upstream and downstream)",
            list1: "Local content compliance (Nigerian Content Development Act)",
            list2: "Gas sales agreements (GSAs) and lifting contracts",
            list3: "Power Purchase Agreements (PPAs) and regulatory filings",
            list4: "Environmental compliance and ESG disclosures",
            list5: "Joint venture and farm-in/farm-out agreements",
            list6: "Tax optimization for extractive operations",
          },
          {
            heading: "Our Legal Solutions for the Energy Industry",
            desc: "We provide practical, sector-specific legal services across oil, gas, and renewable energy:",
            list1: "✅ Regulatory Approvals & Licensing",
            list2: "Guidance on NUPRC permits, NERC licenses, export consents, and midstream facility approvals.",
            list3: "✅ Contracts & Transactions:",
            list4: "Drafting and negotiating EPC contracts, MOUs, Joint Operating Agreements (JOAs), PSAs, and asset transfers.",
            list5: "✅ Renewables & Infrastructure",
            list6: "Legal support for solar, hydro, and mini-grid developers under Nigerian Electrification Project (NEP) and REA schemes.",
            list7: "✅ Environmental & ESG",
            list8: "Legal advice on host community agreements, environmental assessments, and ESG compliance.",
            list9: "✅ Dispute Resolution",
            list10: "Oilfield disputes, JV disagreements, local content infractions, and arbitration support.",
          },
          {
            heading: "Real-Life Use Case",
            list1: "A Lagos-based solar power startup faced delays securing a rural electrification license. Lawberon assisted with REA documentation, NERC filings, and drafted a watertight Power Purchase Agreement with a State Government, helping the project close funding within 60 days.",
          },
        ],
        workWithUs: [
          {
            list: "Industry Experience: We’ve advised energy clients across upstream, downstream, renewables, and ESG."
          },
          {
            list: "Local-Global Fluency: Nigerian regulations with international deal structuring."
          },
          {
            list: "Rapid Support: Time-sensitive licenses and filings managed efficiently."
          },
        ],
      }
    ],
  },
  {
    category: "Educational Institutions & EdTech Ventures",
    item: [
      {
        title: "Educators Are Evolving — But the Laws Are Catching Up Slowly",
        paragraph: "From elite private schools in Lagos to rising EdTech startups and NGO-funded learning hubs, Nigeria’s education space is growing — fast. But that growth often collides with slow-moving government regulation, unclear licensing processes, and cross-border legal grey areas.",
        paragrap2: "Whether you're building a tech-powered curriculum, opening a foreign-branded school, or structuring a non-profit for donor funding, the legal framework matters. That’s where Lawberon Legals comes in.",
        paragrap3: "We help founders, school owners, EdTech innovators, and NGOs get legally structured, stay compliant, and focus on delivering impact.",
        details: [
          {
            heading: "Common Legal Hurdles in Education & EdTech",
            desc: "Here’s what we’ve helped clients tackle:",
            list1: "❌ Operating without NUC, NBTE, or Ministry of Education accreditation",
            list2: "❌ Using unregistered school names or unprotected brand content",
            list3: "❌ Confusing franchise terms with foreign schools or academies",
            list4: "❌ Infringement issues from copied digital courseware",
            list5: "❌ Poor teacher employment agreements and IP clauses",
            list6: "❌ Missing data protection measures for student/parent data",
            list7: "❌ NGO schools misaligned with CAC or donor requirements",
          },
          {
            heading: "Legal Services Tailored to Educators & Innovators",
            desc: "Our legal solutions are designed to keep your education venture credible, compliant, and investor-ready:",
            list1: "✅ For Private Schools, Colleges & Institutions",
            list2: "CAC incorporation + education-specific object clause",
            list3: "Ministry of Education & NUC/NBTE licensing support",
            list4: "School policies, code of conduct, and staff agreements",
            list5: "Franchise & affiliation agreements with international institutions",
            list6: "Real estate due diligence for school site acquisition",
            list7: "✅ For EdTech Startups & Digital Creators",
            list8: "IP protection for digital courses, platforms, and apps",
            list9: "Terms & Conditions, Privacy Policies, and NDAs",
            list10: "NITDA compliance and data protection frameworks",
            list11: "Revenue-sharing contracts with content creators or tutors",
            list12: "Licensing deals with schools, ministries, or publishers",
            list13: "✅ For NGOs & International Education Projects",
            list14: "NGO registration with CAC (Trusteeship or Ltd by Guarantee)",
            list15: "Donor agreement review and legal structuring for grant use",
            list16: "Cross-border contracts with global education partners",
            list17: "Asset protection and governance for long-term educational programs",
          },
          {
            heading: "Real-Life Client Scenarios",
            desc: "✅ A tech-enabled learning platform needed help formalizing co-founder shares, licensing course materials, and drafting clear tutor agreements. We handled their IP filings, NDA structure, and investor readiness.",
            list1: "✅ A private sixth-form college in Abuja wanted to affiliate with a UK institution. We navigated the franchise contract, handled licensing permits, and ensured all content was IP compliant.",
            list2: "✅ An NGO launching a mobile literacy project needed registration, donor contract vetting, and NITDA compliance. We delivered end-to-end support, including foreign remittance planning.",
          },
        ],
        workWithUs: [
          {
            list: "We speak school + startup. From blackboards to dashboards, we understand both traditional and tech-enabled models."
          },
          {
            list: "Licensing made easy. We’ve navigated CAC, MOE, NUC, NBTE, NITDA — so you don’t have to."
          },
          {
            list: "International support. Partnering with foreign institutions or receiving donor funds? We know how to structure it."
          },
          {
            list: "Fast, friendly service. Legal doesn’t have to be slow or stiff. We get you up and running, fast."
          }
        ],
      }
    ],
  },
  {
    category: "NGOs, Donor Agencies & Non-Profits",
    item: [
      {
        title: "Making Legal Compliance as Purposeful as Your Mission",
        paragraph: "Running an NGO, church, mosque, or nonprofit in Nigeria comes with a noble vision — but also a surprising amount of legal landmines. From regulatory filings and tax exemptions to donor agreements and governance disputes, the mission can get derailed without a solid legal foundation.",
        paragraph2: "At Lawberon Legals, we help mission-driven organizations protect their work, earn public trust, and stay legally accountable without losing their focus. Whether you're a startup nonprofit, a multinational charity, or a grassroots faith community, we bring strategic legal insight with heart.",
        details: [
          {
            heading: "Key Legal Needs for Purpose-Led Organizations",
            desc: "Here are some common legal headaches we help you avoid:",
            list1: "⛓ Entity registration with CAC under Part F (Incorporated Trustees)",
            list2: "⚡ Donor funding agreements, MoUs, and impact contracts",
            list3: "✉ NGO-friendly tax planning and FIRS compliance",
            list4: "📅 Annual reporting and regulatory filing with CAC, SCUML, etc.",
            list5: "🤔 Internal governance structure (board formation, resolutions, dispute management)",
            list6: "🌎 Cross-border operations and INGO structuring",
            list7: "⚠ IP and brand protection for your cause or campaign",
          },
          {
            heading: "Our Legal Solutions for Nonprofits, Faith Communities & Social Ventures",
            desc: "We provide strategic legal support for:",
            list1: "✅ NGO Incorporation & CAC Compliance ➔",
            list2: "We help you register under the correct CAC category (Part F), draft a compliant constitution, and guide you through post-incorporation filings.",
            list3: "✅ Faith-Based Organization Structuring",
            list4: "For churches, mosques, and religious institutions, we assist with trustee governance, land acquisitions, and tax exemption strategies.",
            list5: "✅ Donor & Impact Funding Agreements",
            list6: "Review and draft grant agreements, foreign donor contracts, local MoUs, and ensure accountability structures that keep funders happy.",
            list7: "✅ Governance & Board Advisory",
            list8: "We advise boards on internal policies, ethical compliance, succession, and regulatory filings.",
            list9: "✅ Tax, SCUML & AML/CFT Compliance",
            list10: "Registration with FIRS, SCUML filing, and advisory to comply with Nigeria’s anti-money laundering laws",
            list11: "✅ Cross-border NGO Structuring",
            list12: "We guide INGOs setting up in Nigeria or local NGOs expanding internationally",
            list13: "✅ Cause-Driven IP Protection",
            list14: "Trademark your NGO brand, protect your publications, training materials, and online advocacy platforms.",
          },
          {
            heading: "Real-Life Use Cases / Client Scenarios",
            list1: "A youth development nonprofit needed to register with CAC and get SCUML clearance for a UK donor — we handled it end-to-end in 3 weeks.",
            list2: "A megachurch wanted to acquire land and structure property ownership legally through trustees — we advised on land law, CAC filings, and governance.",
            list3: "An NGO founder launching a national mental health campaign needed content IP protection and influencer contracts — we drafted both.",
          },
        ],
        workWithUs: [
          {
            list: "🌟 Sector fluency: We understand the tension between purpose and regulation."
          },
          {
            list: "🌐 Local + global alignment: We support both homegrown charities and international donor-backed entities."
          },
          {
            list: "⏳ Quick turnaround: We don’t let paperwork slow down your progress."
          },
        ],
      }
    ],
  },
  {
    category: "Fintech, Payments & Digital Finance Companies",
    item: [
      {
        title: "Helping Innovators Navigate Regulation, Protect IP, and Scale in Nigeria’s Fintech Boom",
        details: [
          {
            heading: "Why Legal Counsel is Crucial for Fintech Growth 🚀",
            desc: "Nigeria's fintech industry is one of the most dynamic in Africa — home to unicorn startups, rising payment companies, and blockchain pioneers. But with innovation comes legal complexity: licensing, data privacy, regulatory hurdles, IP protection, and cross-border compliance.",
            list1: "At Lawberon Legals & Co., we help fintech companies cut through the legal red tape with smart, future-focused legal strategies that protect your interests and drive scalability.",
            desc2: "Whether you're a payment processor, digital bank, lending platform, or crypto innovator, we offer tailored legal solutions that move at the speed of tech.",
          },
          {
            heading: "🔍 What We Do for Fintech Clients",
          },
          {
            heading: "1. Fintech Licensing & Regulatory Approvals",
            desc: "We help you identify the right license and secure approval from regulators like:",
            list1: "Central Bank of Nigeria (CBN)",
            list2: "Securities & Exchange Commission (SEC)",
            list3: "National Information Technology Development Agency (NITDA)",
            list4: "Nigeria Data Protection Commission (NDPC) From Payment Service Provider (PSP) licenses to digital lending compliance, we guide you through complex frameworks like:",
            list5: "CBN’s Payment Systems Regulations",
            list6: "NDPR (Nigeria Data Protection Regulation)",
            list7: "SEC Rules on Crowdfunding & Virtual Assets",
            desc2: "✅ Bonus: We also assist with remittance, BDC, microfinance, and switching license strategies.",
          },
          {
            heading: "2. Corporate Structuring for Fintech Startups",
            desc: "The right legal structure can make or break your fintech venture. We advise on:",
            list1: "Incorporation in Nigeria or offshore (e.g., Delaware, Mauritius, BVI)",
            list2: "Shareholding & cap table structuring",
            list3: "VC/Angel investment compliance",
            list4: "IP holding company strategies",
            list5: "Group company setups for African or global scaling",
          },
          {
            heading: "3. Drafting & Reviewing Key Fintech Agreements",
            desc: "We create and vet the contracts that keep your fintech business compliant and secure:",
            list1: "API and White-label Agreements",
            list2: "Merchant Onboarding Contracts",
            list3: "Payment Gateway & Switching Agreements",
            list4: "Mobile App Terms of Use & Privacy Policies",
            list5: "Digital Lending Terms",
            list6: "NDAs, Service Level Agreements (SLAs), and Partner MOUs",
          },
          {
            heading: "4. Intellectual Property Protection",
            desc: "Fintechs are built on code, algorithms, and proprietary processes. We help protect them:",
            list1: "Software and platform copyright registration",
            list2: "Trademark protection (logos, product names)",
            list3: "Patent strategies for innovations",
            list4: "IP licensing & transfer agreements",
            list5: "Brand protection enforcement",
          },
          {
            heading: "5. Data Protection & Cybersecurity Compliance",
            desc: "With increasing focus on data, we ensure you’re compliant with:",
            list1: "NDPR compliance setup & audit",
            list2: "Privacy policies for web/mobile platforms",
            list3: "Data Processing Agreements",
            list4: "Employee and third-party confidentiality controls",
            list5: "Cross-border data transfer frameworks",
            desc2: "✅ We also help prepare for global standards like GDPR and ISO 27001 if you’re expanding internationally.",
          },
          {
            heading: "6. Crypto, Blockchain & Web3 Legal Support",
            desc: "Nigeria’s evolving crypto space is high-risk, high-reward. We help:",
            list1: "Interpret regulatory positions from SEC and CBN",
            list2: "Structure DAO or token offerings within existing legal frameworks",
            list3: "Draft whitepapers and tokenomics structures",
            list4: "Build risk-mitigated pathways for DeFi and NFT ventures",
          },
          {
            heading: "7. Employment & Executive Contracts",
            desc: "As your team grows, we ensure:",
            list1: "Proper founder agreements",
            list2: "ESOP (Employee Stock Option Plan) documentation",
            list3: "Employment contracts for tech and compliance staff",
            list4: "Contractor vs. full-time classification compliance",
          },
          {
            heading: "8. Dispute Avoidance & Resolution",
            desc: "From chargeback conflicts to co-founder disputes, we handle:",
            list1: "Pre-litigation strategy",
            list2: "Regulatory dispute mediation (CBN, SEC)",
            list3: "Litigation support in courts and arbitration",
            list4: "Investor/shareholder dispute resolution",
          },
          {
            heading: "💡 Who We Serve",
            desc: "Fintech Founders & Startups",
            list1: "Payment & Switching Companies",
            list2: "Digital Banks / Neobanks",
            list3: "Lending Platforms & BNPL Providers",
            list4: "Crypto & Blockchain Projects",
            list5: "Regtech & Insurtech Companies",
            list6: "Mobile Money Operators & PSPs",
            list7: "Foreign companies entering Nigeria’s fintech space",
          },
        ],
        workWithUs: [
          {
            list: "✅ Tech-Savvy Lawyers: We speak your language — APIs, smart contracts, term sheets, and all."
          },
          {
            list: " ✅ Regulatory Expertise: We monitor the evolving fintech landscape, so you don’t have to"
          },
          {
            list: " ✅ Startup-Friendly Approach: We know speed matters. We’re agile, responsive, and growth-minded."
          },
          {
            list: " ✅ Local & International Experience: Whether you’re a Lagos-based startup or a global player entering Nigeria, we’ve got you covered."
          },
        ],
      }
    ],
  },
  {
    category: "Logistics, Mobility & Transport Companies",
    item: [
      {
        title: "Navigating Legal Pathways in Nigeria's Movement Economy",
        paragraph: "Nigeria's logistics and mobility sectors are growing rapidly, powered by e-commerce, on-demand delivery, fleet-based mobility, ride-hailing apps, and interstate freight services. Yet this boom is happening in a complex regulatory environment riddled with fragmented transport laws, overlapping agency requirements, and risks from accidents, liability, taxation, and compliance.",
        paragraph2: "That’s where Lawberon Legals & Co. comes in. We partner with logistics startups, fleet operators, haulage companies, courier services, and transport tech platforms to deliver sharp, proactive legal solutions tailored to this dynamic sector",
        details: [
          {
            heading: "Key Legal Needs in Transport & Logistics",
            list1: "Regulatory licensing from NIPOST, FRSC, LASDRI, and State Transport Ministries",
            list2: "Transport liability and accident claims management",
            list3: "Risk exposure from delivery partners and drivers",
            list4: "Commercial contracts for warehousing, last-mile delivery, and vendor management",
            list5: "Fleet insurance, leasing, and financing arrangements",
            list6: "Labour laws, driver contracts, and staff outsourcing agreements",
            list7: "Digital platform terms & conditions for ride-hailing or dispatch apps",
            list8: "Taxation across states (for inter-state operations)",
            list9: "Intellectual Property protection for tech-enabled logistics brands",
          },
          {
            heading: "Our Legal Solutions for the Logistics Sector",
            desc: "We offer tailored support for transport ventures and mobility platforms, including:",
            list1: "Startup Structuring & Licensing: Business registration, transport licenses, NIPOST approvals",
            list2: "Fleet & Driver Contracts: Legally sound agreements to reduce disputes and limit liabilities",
            list3: "Risk Mitigation & Insurance Advisory: Structuring indemnities, policies, and claims strategy",
            list4: "Terms of Service for Digital Platforms: Custom-drafted platform agreements for apps & web services",
            list5: "Logistics Compliance Advisory: Guidance on haulage laws, LASAA regulations, and driver safety policies",
            list6: "Tax Optimization: Multi-state tax advisory, withholding tax setup, VAT and cross-border compliance",
            list7: "IP Protection: Trademark registration for your platform name, app, and logistics tech tools",
          },
          {
            heading: "Use Case Scenarios",
            desc: "A bike-hailing startup seeking driver contracts and user policies before raising funds",
            list1: "A freight company needing insurance structuring and interstate transport permits",
            list2: "An e-commerce logistics provider setting up last-mile delivery terms with agents",
            list3: "A fleet owner dealing with recurring driver disputes and accident liabilities",
          },
        ],
        workWithUs: [
          {
            list: "Deep experience in transport law, platform regulation, and logistics structuring"
          },
          {
            list: "Flexible solutions for bootstrapped startups to large-scale fleet operators"
          },
          {
            list: "Responsive legal support for daily contract reviews, compliance filings, and claims management"
          },
          {
            list: "Dual insight: We understand tech innovation and Nigerian agency compliance"
          }
        ],
      }
    ],
  },
  {
    category: "Gaming, Betting & Web3 Ventures",
    item: [
      {
        title: "Nigeria’s Digital Frontier Is Booming — But So Are the Legal Risks",
        paragraph: "From crypto games and sports betting platforms to NFT collectibles and blockchain startups, Nigeria's digital economy is attracting young founders, foreign investors, and a curious user base. But this excitement comes with complex regulation, uncertain enforcement, and high compliance expectations from local and international bodies.",
        paragraph2: "Lawberon Legals helps gaming, betting, and Web3 ventures operate legally and securely in Nigeria. Whether you're launching a play-to-earn ecosystem, a DeFi-powered sportsbook, or a blockchain collectibles brand, our team guides you through licensing, IP, data protection, and tax.",
        details: [
          {
            heading: "Common Legal Needs in This Industry",
            list1: "National Lottery Regulatory Commission (NLRC) licensing",
            list2: "Nigerian Communications Commission (NCC) digital platform compliance",
            list3: "Intellectual property for games, NFTs, brand assets",
            list4: "Anti-money laundering (AML) and KYC procedures",
            list5: "Smart contract auditing and DAO structuring",
            list6: "Terms of service and community guidelines",
            list7: "Cross-border investor documentation & repatriation",
          },
          {
            heading: "Our Legal Solutions for Digital Gaming & Web3 Projects",
            desc: "We provide tailored legal advisory for ventures across:",
            list1: "✅ Sports Betting & Gaming:",
            list2: "Regulatory licensing (NLRC), partnership contracts, user liability coverage.",
            list3: "✅ NFTs & Digital Art:",
            list4: "Copyright strategy, minting terms, resale royalties structuring.",
            list5: "✅ Crypto Tokens & Web3 Projects:",
            list6: "Smart contract legality, DAO incorporation, investor memos.",
            list7: "✅ Mobile Gaming Platforms: ",
            list8: "IP protection, user terms, content licensing deals.",
            desc2: "We ensure your model stays compliant, investable, and community-friendly.",
          },
          {
            heading: "Real-Life Scenarios We Handle",
            list1: "Assisted a Nigerian NFT marketplace with copyright strategy and global terms of use.",
            list2: "Secured betting licenses for a Lagos-based gaming startup targeting Pan-African users.",
            list3: "Helped a Web3 gaming DAO navigate Nigerian regulation while onboarding US-based investors.",
          },
        ],
        workWithUs: [
          {
            list: "Ahead of the Curve: We follow evolving tech regulation closely."
          },
          {
            list: "Regulatory-Startup Fluent: We speak both code and compliance."
          },
          {
            list: "Investor-Ready Contracts: Your paperwork is VC-grade and crypto-proof."
          },
        ],
      }
    ],
  },
  {
    category: "Manufacturers, Traders & Industrial Operators",
    item: [
      {
        title: "Powering Nigeria's Industrial Growth",
        paragraph: "Tailored legal solutions for factories, industrial parks, importers, exporters, and trade players.",
        details: [
          {
            heading: "Why Legal Support Is Crucial in Nigeria's Manufacturing & Trade Sectors",
            desc: "Nigeria's push for local production, industrialization, and non-oil exports is reshaping the landscape for manufacturers and traders. But from licensing hurdles to regulatory compliance and land acquisition headaches, legal missteps can derail even the most promising operations.",
            desc2: "At Lawberon Legals, we serve as the legal engine room for industrial ventures. Whether you're setting up a factory in Ogun, running an agro-processing plant in Kaduna, or importing equipment through Lagos ports, our business-savvy legal counsel keeps you moving.",
          },
          {
            heading: "Key Legal Needs of Manufacturers & Trade Operators",
            list1: "Business Structuring & Regulatory Approvals",
            list2: "Industrial Land Acquisition & Lease Agreements",
            list3: "Local Content & Export Compliance (SON, NAFDAC, NEPC, etc.)",
            list4: "Customs, Import-Export Licensing & Port Logistics",
            list5: "Labor Law & Workforce Contracts",
            list6: "Factory Compliance with Environmental & Safety Laws (NESREA, LASEPA)",
            list7: "Tax Optimization for Industrial Players",
          },
          {
            heading: "Our Legal Solutions for Manufacturing & Trade",
            desc: "We help industrial players operate legally, scale efficiently, and avoid disruptions. Our services include:",
            list1: "Company Setup & Licensing: SONCAP registration, NAFDAC permits, NEPC certificates",
            list2: "Industrial Property Advisory: Factory land due diligence, industrial lease drafting, local permits",
            list3: "Customs & Trade Law: Import-export documentation, bonded warehouse setup, free zone guidance",
            list4: "Labor & Compliance Advisory: Employment contracts, union negotiations, health & safety regulations",
            list5: "Contract Negotiation: With equipment suppliers, off-takers, government agencies, and logistics partners",
            list6: "Local Content Strategy: Advisory on meeting Nigeria's local sourcing mandates",
            list7: "Regulatory Liaison: Navigating SON, NESREA, NAFDAC, and Customs without headaches",
          },
          {
            heading: "Sample Scenarios We've Handled",
            list1: "Helped a Chinese-backed manufacturer set up in Ogun State’s industrial corridor, secure land, get NAFDAC/SON licenses, and structure factory ownership via a local JV.",
            list2: "Supported an export trader in securing NEPC certification and creating airtight contracts with European buyers.",
            list3: "Advised a Lagos-based FMCG firm on reducing customs delays by reworking their import documentation structure.",
          },
        ],
        workWithUs: [
          {
            list: "Sector Insight: Deep experience with manufacturing, agro-processing, logistics, and industrial land deals"
          },
          {
            list: "Regulatory Network: We know the bottlenecks and how to navigate SON, Customs, NESREA, NEPC, and state agencies"
          },
          {
            list: "Pro-Business Mindset: We don’t just check legal boxes — we align law with your business growth"
          },
        ],
      }
    ],
  },
];
